import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  data :any={
    'UM_Full_Name':''
  }
    constructor(public router:Router,public appservice:AppService) {
     
    if (this.getData()) {
      this.data=JSON.parse(localStorage.getItem('User_Data'));
      appservice.Current_User=this.data;
      appservice.Company="_"+this.data.UM_Company;
      this.appservice.get_Token();
      this.get_Reference();
      this.appservice.get_Chit_Value_Master();
    }

     }

     getData() {
      return JSON.parse(localStorage.getItem('User_Data'));
    }
     Prow=[];
     page="";
     get_Reference() {

      this.appservice.getc("Api/Master/get_reference").subscribe((res: any) => {
       this.appservice.Reference_Rows = JSON.parse(res).record;
       this.appservice.get_Role_Rights(this.data.UM_Rights);
       this.appservice.CREATED_BY=this.data.UM_Full_Name;
       this.appservice.Rights_ID=this.data.UM_Rights;
  
       this.appservice.Emp_ID=this.data.Emp_ID;
       try{
       this.Prow = this.appservice.Reference_Rows.filter(e => e.Ref_ID=="User_Role");
       this.appservice.Rights_Name=this.Prow.filter(e => e.RGV_iID.toLowerCase()==this.data.UM_Rights)[0].RGV_vDesciption;
       this.appservice.U_Rights=this.appservice.Rights_Name.toLowerCase();
  
       this.appservice.Header_Disp = this.data.CM_Name;
  
      if(!(this.appservice.Rights_Name.toLowerCase()=="admin"))
      {
        this.appservice.Search_User=this.data.UM_User_Name;
      }
       }catch{}
       this.get_Field_Setting();
  try
  {
  
     this.page=this.Prow.filter(e => e.RGV_iID.toLowerCase()==this.data.UM_Rights)[0].RGV_vCode;
     if(this.data.UM_Rights == '41' || this.data.UM_Rights == 41) {
         this.page = '/report/Summary-Report';
         this.appservice.Lab_Home_Page = this.page;
     }
       this.router.navigate([this.page]);
  }catch{
     if(this.data.UM_Rights == '41' || this.data.UM_Rights == 41) {
         this.page = '/report/Summary-Report';
         this.appservice.Lab_Home_Page = this.page;
     }
    this.router.navigate([this.page]);
  }
      });
    }


    get_Field_Setting() {
      this.appservice.getc("Api/Setting/get_Field_Setting").subscribe((res: any) => {
  
        if(res=="No_Licence")
        {
          this.router.navigate(['/invalid-licence']);
        }
        else
        {
            this.appservice.Field_Setting = JSON.parse(res).record;
            //this.get_Setting_Setting();    
        }
      });
  
  
    }


     addReset() {
      this.appservice.isadd = "0";
      return this.router.navigate(['/change-password']);
    }
    
     lenth:number=0;

     toggleSidebar() {
       this.appservice.isSidebarOpen = !this.appservice.isSidebarOpen;
     }

     logout()
     {
      localStorage.clear();
   
      this.appservice.Company="";
      this.router.navigate(['/'], { replaceUrl: true });
     }
     get_Home()
     {
      return this.router.navigate([this.appservice.Lab_Home_Page]);

     }

     get_Search()
     {
      this.appservice.Search_Customer = "" ;
      return this.router.navigate(['/report/subscriber-history']);

     }
     Bill()
     {
      return this.router.navigate(['/transaction/patient-entry']);
     }

     
     Result()
     {
      return this.router.navigate(['/transaction/test-entry-details']);
     }
     
     search()
     {
      return this.router.navigate(['/transaction/search-patient']);

     }


    ngOnInit() {
    }


   
}
